import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { EditIcon, EyeOffIcon, EyeOnIcon } from "../../assets/Icons";
import Modal from "../Modal";
import Loader from "../Loader";

import {
  setGlobalData,
  setLocalData,
  deleteLocalData,
  setcsvReadedData,
} from "../../store/reducers/globalReducer";
import {
  useOpenAiCompletionRequestHeadlineArrayMutation,
  useOpenAiCompletionRequestArrayMutation,
  useOpenAiGenerateCategoryMutation,
} from "../../store/services/openAiService";
import UpdateHeadlineModel from "../UpdateHeadlineModel";
import Spinner from "../Spinner";

const GlobalHeadline = ({ item }) => {
  const dispatch = useDispatch();

  const { globalData, localData, formInfo, lang } = useSelector(
    (state) => state.globalReducer
  );
  const { userId } = useSelector((state) => state.authReducer);

  const toastObject = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
  };

  const [completionRequest, data] =
    useOpenAiCompletionRequestHeadlineArrayMutation();

  const [selectedHeadlinesArray, setSelectedHeadlinesArray] = useState([]);
  const [openUpdateHeadline, setOpenUpdateHeadline] = useState(false);
  const [updatedHeadlineVal, setUpdatedHeadlineVal] = useState();
  const [updatedHeadlineIndex, setUpdatedHeadlineIndex] = useState();
  const [userInputProductName, setUserInputProductName] = useState(
    formInfo.pName ? formInfo.pName : ""
  );
  const [userInputProductDescription, setUserInputProductDescription] =
    useState(formInfo.pDesc ? formInfo.pDesc : "");
  const promptHeadline = `Product Name: ${userInputProductName}\nProduct Description:${userInputProductDescription}\nAd Headline:`;

  const submitCompletionRequestHeadline = () => {
    if (userInputProductName === "") {
      toast.error("Enter Product Name!", toastObject);
    } else if (userInputProductDescription === "") {
      toast.error("Enter Product Description!", toastObject);
    } else {
      if (lang.value === "german") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `
          Erstelle eine überzeugende Google Ads Überschrift für das folgende Produkt.
          **Nutzer nehmen vor allem die Texte in den Überschriften zur Kenntnis, sie sollten darum wenn möglich die Worte enthalten, die die Nutzer auch in die Google Suche eingegeben haben. Deine Anzeige besteht aus 3 Überschriften mit jeweils bis zu 30 Zeichen, in denen dein Produkt oder deine Dienstleistung beworben wird. Die Überschriften werden durch einen vertikalen Strich ("|") voneinander getrennt dargestellt.**
          Product Name: ${userInputProductName}
          Product Description: ${userInputProductDescription}
          Ad Headline:
          `,
        });
      } else if (lang.value === "germanF") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Erstelle eine überzeugende Google Ads Überschrift für das folgende Produkt. Verwende die formelle Ansprache “Sie”, wenn der Nutzer im Text direkt angesprochen wird. *Nutzer nehmen vor allem die Texte in den Überschriften zur Kenntnis, sie sollten darum wenn möglich die Worte enthalten, die die Nutzer auch in die Google Suche eingegeben haben. Deine Anzeige besteht aus 3 Überschriften mit jeweils bis zu 30 Zeichen, in denen dein Produkt oder deine Dienstleistung beworben wird. Die Überschriften werden durch einen vertikalen Strich ("|") voneinander getrennt dargestellt.* Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Ad Headline`,
        });
      } else if (lang.value === "germanInF") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Erstelle eine überzeugende Google Ads Überschrift für das folgende Produkt. Verwende die informelle Ansprache “Du”, wenn der Nutzer im Text direkt angesprochen wird *Nutzer nehmen vor allem die Texte in den Überschriften zur Kenntnis, sie sollten darum wenn möglich die Worte enthalten, die die Nutzer auch in die Google Suche eingegeben haben. Deine Anzeige besteht aus 3 Überschriften mit jeweils bis zu 30 Zeichen, in denen dein Produkt oder deine Dienstleistung beworben wird. Die Überschriften werden durch einen vertikalen Strich ("|") voneinander getrennt dargestellt.* Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Ad Headline:`,
        });
      } else {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Create a compelling Ad Headline for the following Product to run on Google Search. **People are most likely to notice your headline text, so consider including words that people may have entered in their Google search. Your text ad consists of three headlines where you can enter up to 30 characters each to promote your product or service. The headlines are separated by a vertical pipe ("|").** Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Ad Headline:`,
        });
      }
    }
  };

  useEffect(() => {
    if (data.isSuccess) {
      const updatedHeadlines = [
        ...globalData?.headlines,
        ...data?.data?.message,
      ];
      dispatch(setGlobalData({ ...globalData, headlines: updatedHeadlines }));
    }
  }, [data.isSuccess]);

  useEffect(() => {
    const oldHeadlines = [...globalData?.headlines];
    if (updatedHeadlineIndex !== -1) {
      oldHeadlines[updatedHeadlineIndex] = updatedHeadlineVal;
      dispatch(
        setGlobalData({
          ...globalData,
          headlines: oldHeadlines,
        })
      );
    }
  }, [updatedHeadlineVal]);

  useEffect(() => {
    setUserInputProductName(formInfo.pName ? formInfo.pName : "");
    setUserInputProductDescription(formInfo.pDesc ? formInfo.pDesc : "");
  }, [formInfo]);

  const handleHeadlinesArray = (e, item) => {
    // Destructuring
    const { value, checked } = e.target;

    // Case 1 : The user checks the box
    if (checked) {
      selectedHeadlinesArray.push(item.trim());
    }
    // Case 2  : The user unchecked the box
    else {
      let newSelectedHeadlinesArray = selectedHeadlinesArray.filter(function (
        filterItem
      ) {
        return filterItem.trim() !== item.trim();
      });
      setSelectedHeadlinesArray(newSelectedHeadlinesArray);
    }
  };
  const PostHeadlines = () => {
    if (selectedHeadlinesArray.length) {
      const updatedOldArray = localData.map((item, index) => {
        let newRow = { ...item };
        const keys = Object.keys(newRow);
        const count = keys.length;
        for (let i = 0; i < selectedHeadlinesArray.length; i++) {
          let headlineNum = count + i;
          newRow[`Headline ${headlineNum}`] = selectedHeadlinesArray[i];
        }
        return newRow;
      });
      dispatch(setLocalData(updatedOldArray));
      toast.success("Headlines added successfully in all rows!", toastObject);
    }
  };

  return (
    <div className="global-row-expend-block flex flex-col">
      <div className="expend-row-headline flex flex-col items-center">
        <div className="expend-row-headline-top flex">
          <div className="input-field flex flex-col w-2/5">
            <div className="input-tag font-semibold text-base mb-2">
              Product/Service Name
            </div>
            <textarea
              id="pName"
              type="text"
              className="txt-seach-key min-h-[100px] max-h-[100px] overflow-hidden"
              placeholder="Product/Service Name"
              value={userInputProductName}
              onChange={(e) => setUserInputProductName(e.target.value)}
            />
          </div>
          <div className="input-field flex flex-col w-full">
            <div className="input-tag font-semibold text-base mb-2">
              Product/Service Summary
            </div>
            <textarea
              type="text"
              className="txt-seach-key w-full min-h-[100px] max-h-[100px] overflow-hidden"
              placeholder="Product/Service Summary"
              value={userInputProductDescription}
              onChange={(e) => setUserInputProductDescription(e.target.value)}
            />
          </div>
          <input
            type="submit"
            value={data.isLoading ? "Processing..." : "Generate Ideas"}
            className="btn button h-12 mt-8"
            onClick={(e) => submitCompletionRequestHeadline(e)}
          />
        </div>
        <div className="flex items-start my-3 w-full">
          <p className="text-lg text-red-700 font-semibold text-start w-full">
            Click Cloud Icon to generate a summary of your landing page
          </p>
        </div>
        <div className="flex items-center w-full">
          <div className="expend-tag flex flex-1 text-center items-center justify-center">
            Global Headlines
          </div>
          <div className="btn button" onClick={(e) => PostHeadlines()}>
            Post to All Ads
          </div>
        </div>
      </div>
      <div className="expend-table-section flex flex-col">
        {data?.isLoading ? (
          <Loader />
        ) : (
          <>
            {globalData?.headlines?.length ? (
              <>
                {globalData?.headlines?.map((itm, idx) => (
                  <div key={idx} className="exp-row flex items-center">
                    <div className="exp-row-item flex items-center">
                      <div className="col-numb">{idx + 1}</div>
                      <div>
                        <input
                          onChange={(e) => {
                            handleHeadlinesArray(e, itm);
                          }}
                          type="checkbox"
                          className="check-box w-5 h-5"
                        />
                      </div>
                    </div>
                    <div className="exp-row-item flex items-center justify-center">
                      {itm === "---" ? null : (
                        <button className="btn button" disabled={true}>
                          {itm?.trim().length}
                        </button>
                      )}
                    </div>
                    <div className="exp-row-item flex items-center">
                      <div className="exp-row-tag">{itm ? itm : "--"}</div>
                    </div>
                    <div className="exp-row-item flex items-center justify-end">
                      <div
                        className="edit-icon flex items-center justify-center cursor-pointer"
                        onClick={(e) => {
                          setOpenUpdateHeadline(true);
                          setUpdatedHeadlineVal(itm);
                          setUpdatedHeadlineIndex(idx);
                        }}
                      >
                        <EditIcon />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="expend-tag text-center font-semibold text-lg">
                Global Headline Empty
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        open={openUpdateHeadline}
        onClose={() => setOpenUpdateHeadline(false)}
      >
        <UpdateHeadlineModel
          setOpen={setOpenUpdateHeadline}
          updatedHeadlineVal={updatedHeadlineVal}
          setUpdatedHeadlineVal={setUpdatedHeadlineVal}
        />
      </Modal>
    </div>
  );
};

export default GlobalHeadline;
